module.exports = __webpack_public_path__ + "assets/img/2021my.70873cdb.png";